/*
	Форма регистрации
*/
class FormRegister extends Form {
	$phoneInput = null;
	$emailInput = null;

	maskCompleted = false;
	iti = null;

	constructor($form) {
		super($form);

		this.$phoneInput = this.$form.find('.js-phone-iti');
		this.$emailInput = this.$form.find('.js-email')

		this.$inputs.filter('[name="login"]')
			.on('maskCompleted', this.onMaskCompleted.bind(this));

		this.$inputs.filter('[name="login"]')
			.on('maskUncompleted', this.onMaskUncompleted.bind(this));

		this.initPhoneInput();
		this.initEmailInput();
	}

	//-------------------------------------------------
	//Инициализация маски телефона
	initPhoneInput() {
		var self = this;

		if (!this.$phoneInput.length)
			return;

		var input = this.$phoneInput[0];

		this.iti = window.intlTelInput(input, {
			autoPlaceholder: 'aggressive',
			showSelectedDialCode: true,
			initialCountry: 'ru',
			dropdownContainer: document.body,
			fixDropdownWidth: true,
			nationalMode: false,
			customPlaceholder: function(selectedCountryPlaceholder) {
				return selectedCountryPlaceholder.replace(/[0-9]/g, '_');
			},
		});

		input.addEventListener('countrychange', function() {
			self.updatePhonePadding();
		});

		this.$phoneInput.on('input', function() {
			var $hidden = $(`#${$(this).data('hidden')}`);

			self.updatePhonePadding();
			$hidden.val(self.iti.getNumber());

			if (self.iti.isValidNumber()) $hidden.trigger('maskCompleted');
			else $hidden.trigger('maskUncompleted');
		});

		setTimeout(function() {
			self.updatePhonePadding();
		}, 10);

		this.$phoneInput.addClass('ok');
	}

	//-------------------------------------------------
	//Инициализация маски email
	initEmailInput() {
		if (!this.$emailInput.length) return;
	
		this.$emailInput.on('keyup', function() {
			var text = $(this).val();
	
			if (
				text.length > 10 && 
				text.includes('@') && 
				text.includes('.')
			)
				$(this).trigger('maskCompleted');

			else $(this).trigger('maskUncompleted');
		});
	}

	//-------------------------------------------------
	//Пересчёт padding маски
	updatePhonePadding() {
		if (!this.$phoneInput.length) return;

		var
			input = this.$phoneInput[0],
			flagContainer = input.parentElement.querySelector('.iti__selected-flag');

		if (flagContainer)
			input.style.paddingLeft = (flagContainer.offsetWidth + 20) + 'px';
	}

	//-------------------------------------------------
	//Событие активации формы
	onActivate() {
		this.updatePhonePadding();
	}

	//-------------------------------------------------
	//Запрос на активацию кнопки для возможности его отмены
	canEnableButton() {
		return this.maskCompleted;
	}

	//-------------------------------------------------
	//Событие завершения маски телефона
	onMaskCompleted() {
		this.maskCompleted = true;
		this.onInputReqChange();
	}

	//-------------------------------------------------
	//Событие отмены маски телефона
	onMaskUncompleted() {
		this.maskCompleted = false;
		this.onInputReqChange();
	}
}